export default __webpack_public_path__ + "static/media/collab.5faa2bfb.svg";